module.exports = __webpack_public_path__ + "static/media/stripe.bda917b5.svg";